import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ITimeLineGraphicModel } from '@types-custom/models/ui/chart-line-color-model';
import { Icon } from '@types-custom/models/ui/icon-model';
import {
  IModalAforoModel,
  IOptionTypeVehicle,
  vehicleTypeEnum,
} from '@types-custom/models/ui/modal-aforo-model';
import { ISpeedometerModel } from '@types-custom/models/ui/speedometer-model';
import { OverlayService } from '@ui-core/services/overlay/overlay.service';
import { ImageDetailComponent } from './image-detail/image-detail.component';
import { forEach } from 'lodash';
@Component({
  selector: 'modal-aforo',
  templateUrl: './modal-aforo.component.html',
  styleUrls: ['./modal-aforo.component.scss'],
})
export class ModalAforoComponent implements OnInit {
  @Input() properties: IModalAforoModel;
  id = ''

  hasInfo = false;
  errorMessage = '';

  graphicChartMap: { [key: string]: () => void } = {
    ['FLUJO']: () => this.lineChart('', 'Hora', ''),
    ['VELOCIDAD']: () => this.lineChart('Km/h', 'Hora', '', true)
  };

  pointsOptions: pointMeasurement[] = [{
    dataId: "0",
    cameraId: "0",
    cameraName: "",
    speed: 0,
    count: 0,
    lane: {
      name: "",
      direction: ""
    },
    pointMeasurementId: "0",
    pointMeasurementName: "Todos",
    vehicleType: "",
    vehicleSuyType: "",
    date: "",
    vehicle: [
      {
        vehicleSuyType: "",
        count: 0
      }
    ]
  }];

  currentPoint!: pointMeasurement;

  Icon = Icon;
  imageModal: any;
  typeOptions: Array<string> = ['FLUJO', 'VELOCIDAD'];
  defaultOption = 'FLUJO';

  graphicDataGraphicList: ITimeLineGraphicModel;
  graphicColorScale: any = [{}];

  dataAvgCountAndSpeed: any[] = [];

  carsFlowIndicator = 0;

  avgSpeedProps: ISpeedometerModel = {
    chartType: 4,
    divId: 'avgSpeed',
    unitLabel: 'Km/h',
    value: 0,
    labelsClass: 'speedometer-spacing',
  };





  get btnTypeIndicators(): IOptionTypeVehicle[] {
    if (!this.currentPoint?.cameraId) return [];

    this.currentPoint.vehicle.forEach((vehicle: any) => {
      const item = this.btnTypeIndicator.find(
        (item) => item.type === vehicle.vehicleSuyType
      );
      if (item) {
        item.value = vehicle.count;
      }
      return [item];
    })
    return this.btnTypeIndicator
  }

  readonly baseIndicators: IOptionTypeVehicle[] = [
    {
      type: vehicleTypeEnum.BUS,
      icon: Icon.bus,
      alt: 'icono indicador de bus',
      active: true,
      value: 0,
      tooltip: 'Autobus',
    },
    {
      type: vehicleTypeEnum.TRUCK,
      icon: Icon.trucks_green,
      alt: 'icono indicador camión',
      active: false,
      value: 0,
      tooltip: 'Camión',
    },
    {
      type: vehicleTypeEnum.VANS,
      icon: Icon.van_green,
      alt: 'icono indicador camioneta tipo van',
      active: false,
      value: 0,
      tooltip: 'Furgonetas',
    },
    {
      type: vehicleTypeEnum.CAR,
      icon: Icon.cars_yellow,
      alt: 'icono indicador automovil',
      active: false,
      value: 0,
      tooltip: 'Automovil',
    },
    {
      type: vehicleTypeEnum.MOTORBIKE,
      icon: Icon.motorcycle_green,
      alt: 'icono indicador motocicleta',
      active: false,
      value: 0,
      tooltip: 'Motocicleta',
    },
    {
      type: vehicleTypeEnum.SCOOTER,
      icon: Icon.scooter_y,
      alt: 'icono indicador scooter',
      active: false,
      value: 0,
      tooltip: 'Scooter',
    },
    {
      type: vehicleTypeEnum.BICYCLES,
      icon: Icon.bicycles_green,
      alt: 'icono indicador bicicleta',
      active: false,
      value: 0,
      tooltip: 'Bicicleta',
    },
    {
      type: vehicleTypeEnum.ADULT,
      icon: Icon.pedestrian_adult,
      alt: 'icono indicador adulto',
      active: false,
      value: 0,
      tooltip: 'Adulto',
    },
    {
      type: vehicleTypeEnum.KID,
      icon: Icon.pedestrian_kid,
      alt: 'icono indicador niño',
      active: false,
      value: 0,
      tooltip: 'Niño',
    },
    {
      type: vehicleTypeEnum.UNKNOWN,
      icon: Icon.others_green,
      alt: 'icono indicador desconocido',
      active: false,
      value: 0,
      tooltip: 'Desconocido',
    },
  ];

  btnTypeIndicator: IOptionTypeVehicle[] = [...this.baseIndicators];

  constructor(
    private overlayService: OverlayService,
  ) { }

  ngOnInit(): void {
    this.id = this.properties?.id;
    this.properties.aforoDataSource.getImageModal(this.properties.id).subscribe({
      next: (objImagen: any) => {
        this.imageModal = objImagen
      },
    })

    this.getDataModal(this.properties.nId)
  }

  vehicleCount = 0;
  motorcycleCount = 0;
  pedestrianCount = 0;

  getDataModal(id: string) {

    this.properties.aforoDataSource.getPanelAforoMeasurements()
      .subscribe({
        next: (res: any) => {
          if (!res?.groupCameras?.length) return;
          this.hasInfo = true;

          const currentCamera = res.groupCameras.find((item: any) => item.cameraId == this.id);

          if (currentCamera) {
            this.vehicleCount = currentCamera.vehicleCount || 0;
            this.motorcycleCount = currentCamera.motorcycleCount || 0;
            this.pedestrianCount = currentCamera.pedestrianCount || 0;
            this.avgSpeedProps.value = currentCamera.speedAverage || 0;
            this.carsFlowIndicator = currentCamera.count || 0;
          }
        },
        error: (err: any) => {
          this.errorMessage = err.message;
          switch (err.status) {
            case 500:
              this.errorMessage = 'El servidor no puede procesar la petición';
              break;
            case 404:
              this.errorMessage = 'No se encontró información del sensor';
              break;
            case 401:
              this.errorMessage = 'No tiene permiso para acceder a los datos';
              break;
            default:
              this.errorMessage = 'Ha ocurrido un error inesperado';
              break;
          }
        }

      })
  }



  transform(imagen: any) {
    if (!imagen) return ''
    const img = `data:image/png;base64,${imagen}`
    return img
  }



  selectedVehicleType(indicator: any) {
    this.btnTypeIndicator.forEach((item: any) => {
      item.active = indicator.type === item.type ? true : false;
    });
    this.graphicChartMap[this.defaultOption]();
  }

  lineChart(label: string = '', labelX: string = '', labelY: string = '', speed: boolean = false): void {
    const dataGraphic: { time: string; value: number }[] = [];

    this.dataAvgCountAndSpeed
      .filter((vehicle: any) =>
        vehicle.vehicleType === this.btnTypeIndicator.find((item) => item.active == true).type)
      .forEach(v => {
        const dataSpeed = v.avgSpeedByHour;
        const dataCount = v.countByHour;
        const len = Math.min(dataSpeed.length, dataCount.length);
        for (let i = 0; i < len; i++) {
          dataGraphic.push({
            time: `${i}`,
            value: speed ? dataSpeed[i] : dataCount[i],
          });
        }
      });
    if (dataGraphic.length <= 0) {
      dataGraphic.push({
        time: '0',
        value: 0,
      });
    }

    this.graphicDataGraphicList = {
      data: dataGraphic,
      label, labelX, labelY,
    };
    this.graphicColorScale = [
      { minValue: 0, maxValue: 10000, color: '#C37E20' },
    ];
  }

  ScrollButton(direction: any) {
    const scrollContainer: HTMLDivElement | null = document.getElementById(`scrollContainer-${this.id}`) as HTMLDivElement;
    if (scrollContainer && direction == 'left') {
      scrollContainer.scrollBy({
        left: 100,
        behavior: 'smooth'
      });
    } else if (scrollContainer && direction == 'right') {
      scrollContainer.scrollBy({
        left: -100,
        behavior: 'smooth'
      });
    } else {
      console.error('No se encontraron los elementos necesarios en el DOM.');
    }
  }

  activeOptions(elemIndex: number) {
    return this.currentPoint = this.pointsOptions[elemIndex];
  }

  openImageModal(image: string) {
    // this.floatingImageModal = image;
    this.overlayService.open({
      component: ImageDetailComponent,
      data: {
        image: image,
        closeModal: () => this.closeImageModal()
      }
      // viewContainerRef: ,
    });
  }
  closeImageModal() {
    this.overlayService.close();
  }
}

interface pointMeasurement {
  dataId: string,
  cameraId: string,
  cameraName: string,
  speed: number,
  count: number,
  lane: {
    name: string,
    direction: string
  },
  pointMeasurementId: string,
  pointMeasurementName: string,
  vehicleType: string,
  vehicleSuyType: string,
  date: string,
  vehicle: [
    {
      vehicleSuyType: string,
      count: number
    }
  ]
}
